const B = 'https://customer-assets-cm19k8pv.emergentagent.net/job_1373bd47-7a24-47ca-adae-0f2fe2678f07/artifacts/';

export const SHOP_URL = 'https://shop.finestfeathers.com/collections/satin-ribbon';
export const NEWSLETTER_FORM_URL = 'https://form.jotform.com/263008257636055';

export const GROUP_SHOTS = {
  gold: `${B}b7201689a529c3d6_IMG_9891.JPG`,
  pinks: `${B}0d7077e740e82bf0_IMG_9893%202.JPG`,
  reds: `${B}224a101ebe162bb7_IMG_9894.JPG`,
  blues: `${B}7a05e426bc8aa7aa_IMG_9895.JPG`,
  purples: `${B}39307ad3175d2e51_IMG_9896%202.JPG`,
  blackGrey: `${B}67e58e9eddba55f3_IMG_9897%202.JPG`,
  blackPattern: `${B}c5d085dd9ec93e47_IMG_9898.JPG`,
};

const BLACK_PATTERN = ['9937', '9935', '9936', '9902', '9900', '9948'];
const withImg = (c) => ({ ...c, img: B + c.img, bp: BLACK_PATTERN.includes(c.img.match(/IMG_(\d{4})/)[1]) });

export const WIDE_COLORS = [
  { name: 'Poppy Rose', hex: '#C8102E', img: '6e65f30f952e2728_IMG_9940.JPG' },
  { name: 'Fandango', hex: '#8B1538', img: '6493b8982826c5d8_IMG_9941.JPG' },
  { name: 'Neon Pink', hex: '#D6246E', img: 'b4574cb07ae7e003_IMG_9942.JPG' },
  { name: 'Geranium Pink', hex: '#EE8FB4', img: '194d944b7ab97e7f_IMG_9944.JPG' },
  { name: 'Amaranth Pink', hex: '#F6B8C4', img: 'f3465e7901fc5767_IMG_9945.JPG' },
  { name: 'Quarts', hex: '#C7949B', img: '061112b461bc597a_IMG_9943.JPG' },
  { name: 'Lt Orchid', hex: '#D8C3E8', img: 'c7b869f1c7786fdf_IMG_9865.webp' },
  { name: 'Heliotrope', hex: '#B293DB', img: '87ee2e71cd5e76b7_IMG_9867.webp' },
  { name: 'Ultra Violet', hex: '#7B1FA2', img: '10261fca6b7dcc88_IMG_9868.webp' },
  { name: 'Purple Haze', hex: '#4B2A9E', img: 'd725531a930ab4b8_IMG_9866.webp' },
  { name: 'cobalt', hex: '#1F3AA8', img: '6f0013cc39637c1f_IMG_9873.webp' },
  { name: 'Aegean Blue', hex: '#3A86C8', img: '67bfbebd24ddd5f8_IMG_9871.webp' },
  { name: 'Misty Turquoise', hex: '#5EC2CC', img: '7e15c8b235bccd04_IMG_9870.webp' },
  { name: 'Alice blue', hex: '#BFE0EA', img: '3e3cf100a0b2bd63_IMG_9872.webp' },
  { name: 'Jade', hex: '#1E8C84', img: '77d4ea3626932da7_IMG_9875.webp' },
  { name: 'Hunter', hex: '#0F6B4A', img: '898d6a95429eadc5_IMG_9876.webp' },
  { name: 'Kiwi', hex: '#8CB82E', img: '1ade1c0cb2b62005_IMG_9874.webp' },
  { name: 'Moss', hex: '#6B7032', img: '8e717f0d889f1b68_IMG_9877.webp' },
  { name: 'Desert Sand', hex: '#C9A774', img: '4d97c35e6aae8ff9_IMG_9878.webp' },
  { name: 'Golden Brown', hex: '#A8743A', img: '9d49051f9251e206_IMG_9879.webp' },
  { name: 'Turftan', hex: '#6E4A26', img: 'a37af18a327f86f5_IMG_9880.webp' },
  { name: 'Metal', hex: '#8E8B88', img: '4f8ba485fb989114_IMG_9939.JPG' },
  { name: 'Black', hex: '#111111', img: '80ab2218e3be6048_IMG_9938.JPG' },
  { name: 'White', hex: '#F4F2EE', img: '35e82648fb7110c9_IMG_9937.JPG' },
  { name: 'Buttermilk', hex: '#F1E3B5', img: 'd3101032cf1b2f52_IMG_9935.JPG' },
  { name: 'Pastel Pink', hex: '#F7C9D6', img: '0c226f997f81358d_IMG_9936.JPG' },
].map(withImg);

export const NARROW_COLORS = [
  { name: 'Poppy Rose', hex: '#C8102E', img: 'a7029c1338b33d7f_IMG_9919.JPG' },
  { name: 'Fandango', hex: '#8B1538', img: '14e50cfb296cffb8_IMG_9920.JPG' },
  { name: 'Neon Pink', hex: '#D6246E', img: 'b95a2614bceebd1a_IMG_9922.JPG' },
  { name: 'Geranium Pink', hex: '#EE8FB4', img: 'e848c1fd25f0f4ed_IMG_9923.JPG' },
  { name: 'Amaranth Pink', hex: '#F6B8C4', img: '9a901e22501e515e_IMG_9925.JPG' },
  { name: 'Quarts', hex: '#C7949B', img: '0ac0b12c5aa645d2_IMG_9924.JPG' },
  { name: 'Lt Orchid', hex: '#D8C3E8', img: 'b0646c383738c002_IMG_9911.JPG' },
  { name: 'Heliotrope', hex: '#B293DB', img: 'ed0e937a4722e31a_IMG_9910.JPG' },
  { name: 'Ultra Violet', hex: '#7B1FA2', img: '1c8209c5e64fae80_IMG_9908.JPG' },
  { name: 'Purple Haze', hex: '#4B2A9E', img: 'e33585f6d999634d_IMG_9909.JPG' },
  { name: 'cobalt', hex: '#1F3AA8', img: '3f5d73c9e4ba9727_IMG_9915.JPG' },
  { name: 'Aegean Blue', hex: '#3A86C8', img: '7133ba7c13d536ee_IMG_9914.JPG' },
  { name: 'Misty Turquoise', hex: '#5EC2CC', img: 'f67a07886fde9c33_IMG_9916.JPG' },
  { name: 'Alice blue', hex: '#BFE0EA', img: '4262b2546dd0d114_IMG_9917.JPG' },
  { name: 'Jade', hex: '#1E8C84', img: 'da27f834f5440d19_IMG_9928.JPG' },
  { name: 'Hunter', hex: '#0F6B4A', img: 'b04b93ca0a5c511e_IMG_9929.JPG' },
  { name: 'Kiwi', hex: '#8CB82E', img: 'f0caf66098d2f4ef_IMG_9927.JPG' },
  { name: 'Moss', hex: '#6B7032', img: 'adc18d6b2ef093d6_IMG_9930.JPG' },
  { name: 'Desert Sand', hex: '#C9A774', img: '561cd6a11878eb55_IMG_9934.JPG' },
  { name: 'Golden Brown', hex: '#A8743A', img: '1d6405d0be068a46_IMG_9932.JPG' },
  { name: 'Turftan', hex: '#6E4A26', img: '40882219590441cb_IMG_9933.JPG' },
  { name: 'Metal', hex: '#8E8B88', img: '1086b5c4fbd2dddd_IMG_9904.JPG' },
  { name: 'Black', hex: '#111111', img: 'a8cb9e65b1413ccc_IMG_9905%202.JPG' },
  { name: 'Buttermilk', hex: '#F1E3B5', img: 'e8c8893c97dd0cf4_IMG_9902.JPG' },
  { name: 'Pastel Pink', hex: '#F7C9D6', img: 'e908b291e579db80_IMG_9900.JPG' },
  { name: 'Orange', hex: '#E8571C', img: '1e10c5e3c16c98ee_IMG_9948.JPG' },
].map(withImg);

export const MARQUEE = ['Native-owned', 'Basket-inspired', 'Satin finish', '10 yards per roll', '1.5" wide', '5/8" wide', '26 colors · 2 sizes', 'Made for makers'];

export const FAQS = [
  { q: 'What widths do you offer?', a: 'Two: a bold 1.5-inch ribbon for statement pieces like ribbon skirts and shirts, and a fine 5/8-inch ribbon for trims, detailing and accessories.' },
  { q: 'How much ribbon is on each roll?', a: 'Every roll holds 10 yards of satin polyester ribbon.' },
  { q: 'Where does the pattern come from?', a: 'Our designs are inspired by California Native basketry and developed by Finest Feathers, an Indigenous-owned California brand.' },
  { q: 'What can I make with it?', a: 'Ribbon skirts, ribbon shirts, regalia accents, hair ties, gift wrapping, home decor and any handmade project that needs a meaningful touch.' },
  { q: 'Can I mix sizes and colors in one order?', a: 'Yes. Add any combination of widths and colors to your cart on our shop.' },
  { q: 'How do I place an order?', a: 'Tap any Shop button to visit our secure Finest Feathers store. Shipping options and costs are shown at checkout.' },
];
